export default `
  name
  url
  mime
  id
`;
